<template>
  <BreadCrumb :PageTitle="pageTitle" />
    <div class="card mb-25 border-0 rounded-0 bg-white create-role-box">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <form @submit.prevent="updateTaskCustomField">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Task Type
                </label>
                <select v-model="selectedTaskType" class="form-select shadow-none fw-semibold rounded-0" disabled>
                  <option v-for="item in taskTypes" :key="item.id" :value="item" >
                     {{ item.taskName }}
                  </option>
              </select>
              </div>
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Custom Field Name
                </label>
                <input
                  v-model="taskCustomField.customFieldName"
                  type="text"
                  class="form-control shadow-none rounded-0 text-black"
                  placeholder="e.g. Administrator"
                  required
                />
              </div>
            </div>
            </div>
            <div class="col-md-12">
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                Update Task Custom Field
              </button>
  
              <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
                pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
                fs-md-15 fs-lg-16 m-5 bg-danger" type="button"> Cancel </button>
                </div>
          </div>
        </form>
      </div>
    </div>
  </template>
    
    <script>
    import { ref, defineComponent, onMounted} from 'vue';
    import { useRoute, useRouter } from "vue-router";
    import { UpdateTaskCustomField, GetAllTaskTypes, FindTaskCustomFieldByID, FindTaskTypeByID } from '@/core/services/entities/task.service';
    import { useToast } from 'vue-toastification';
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  
    export default defineComponent({
      name: 'UpdateTaskCustomField',
      components: {
        BreadCrumb
      },
      setup() {
        const route = useRoute();
        const router = useRouter();
        const taskCustomFieldId = ref(0);
        const selectedTaskType=ref({});
        const taskCustomField=ref({});
        const taskTypes=ref([]);
        const pageTitle = ref("Update Task Custom Field");

        onMounted(async () => {
          taskCustomFieldId.value = route.params.id;
          await getTaskTypes();
          await findTaskCustomFieldByID();
        });

        const goToMainMenu = async () => {
          router.push({ name: "TaskCustomFieldListPage", params: {taskTypeId: selectedTaskType.value.id} });
        };

        const getTaskTypes = async () => {
          const response = await GetAllTaskTypes();
          taskTypes.value = response.taskTypes;
        };

        const findTaskCustomFieldByID = async () => {
          const response = await FindTaskCustomFieldByID(taskCustomFieldId.value);
          taskCustomField.value = response.taskCustomField;

          if(taskCustomField.value != null && taskCustomField.value != undefined)
          {
            const taskTypeResponse = await FindTaskTypeByID(taskCustomField.value.taskTypeId);
            selectedTaskType.value = taskTypeResponse.taskType;
            pageTitle.value = "Update Task Custom Field - " + selectedTaskType.value.taskName;
          }
        };

        const updateTaskCustomField = async () => {
          const toast = useToast();
  
          try {
                const payload = { 
                  id: taskCustomField.value.id,
                  customFieldName:taskCustomField.value.customFieldName,
                  taskTypeId:selectedTaskType.value.id
                };
                
                let response = await UpdateTaskCustomField(payload);  
                if (response.status === 200) {
                  toast.success('Task Custom Field updated successfully!', {
                    timeout: 2000,
                  });
                  goToMainMenu();
                }
              } catch (ex) {
                const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                toast.error(`Failed to update task custom field: ${errorMessage}`, {
                  timeout: 2000,
                });
              }
    
        };
  
        return {
          taskCustomFieldId,
          taskCustomField,
          goToMainMenu,
          updateTaskCustomField,
          selectedTaskType,
          taskTypes,
          pageTitle
        };
      }
    });
    </script>
  
    